import { IncentiveOffer } from 'modules/incentivesMarket/types';
import { IncentivesMarketPlanContext } from 'modules/incentivesMarket/types/IncentivesMarketBeneficiaryContext';
import { getSellerPlanMaxSellableUnits } from 'modules/incentivesMarket/utils/calculateSellerSellLimits';

import { SellPlan } from '../types/SellUnitsSelection';

type MapSellerPlansToSellPlansArgs = {
  offer: Pick<IncentiveOffer, 'unitPrice' | 'sellerParticipationLimits'>;
  sellerPlans: IncentivesMarketPlanContext[];
};

export const getSellPlanRowId = (
  plan: IncentivesMarketPlanContext,
  index: number
): string => {
  const baseId = plan.planId || plan.beneficiaryId;
  return `${baseId}::${index}`;
};

export const mapSellerPlansToSellPlans = ({
  offer,
  sellerPlans,
}: MapSellerPlansToSellPlansArgs): SellPlan[] =>
  sellerPlans.map((plan, index) => {
    const id = getSellPlanRowId(plan, index);
    const availableUnits = Math.max(0, plan.availableUnits ?? 0);
    const maxSellable = getSellerPlanMaxSellableUnits({
      plan,
      sellerParticipationLimits: offer.sellerParticipationLimits,
    });

    return {
      id,
      planId: plan.planId,
      beneficiaryId: plan.beneficiaryId,
      name: plan.planName,
      holdings: availableUnits,
      maxSellable,
      exercisePrice: plan.sharePrice ?? 0,
      salePrice: offer.unitPrice,
      retention: 0,
    };
  });
